import React from 'react';
import { useCourseAccess } from '../hooks/useCourseAccess';
import CoursePaywall from './CoursePaywall';

/**
 * ProtectedModule Component
 * Wraps paid module content with access control.
 * Checks: whitelist > full course_access entitlement > per-module purchased_modules array.
 */
const ProtectedModule = ({ children, moduleNumber = 1, moduleName = null }) => {
  const { hasAccess, accessType, isAuthenticated, isLoading, hasModuleAccess } = useCourseAccess();

  // Module 1 is always free
  if (moduleNumber === 1) return <>{children}</>;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-gold border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600">Checking access...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <CoursePaywall
        isAuthenticated={false}
        moduleNumber={moduleNumber}
        moduleName={moduleName}
      />
    );
  }

  // Whitelisted users always have full access
  if (accessType === 'whitelisted') return <>{children}</>;

  // Per-module or full course access
  if (hasModuleAccess(moduleNumber)) return <>{children}</>;

  return (
    <CoursePaywall
      isAuthenticated={true}
      moduleNumber={moduleNumber}
      moduleName={moduleName}
    />
  );
};

export default ProtectedModule;
